import { EntityType } from "../utils/types";

interface CustomEntity {
  entity_type: string;
  entity_tag: string;
  metadata: {
    [key: string]: string;
  };
  entity_id?: string;
}

// Function to get all custom entities
export const getCustomEntities = async (): Promise<CustomEntity[]> => {
  try {
    const response = await fetch(
      "https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/entity/custom/list"
    );
    if (!response.ok) {
      throw new Error("Failed to fetch custom entities");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching custom entities:", error);
    return [];
  }
};

// Function to create a new custom entity
export const createCustomEntity = async (
  entity: Omit<CustomEntity, "id">
): Promise<CustomEntity | null> => {
  try {
    const response = await fetch(
      "https://backend.endpoints.focal-cooler-451919-j5.cloud.goog/api/entity/custom",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(entity),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to create custom entity");
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating custom entity:", error);
    return null;
  }
};

// Function to delete a custom entity
export const deleteCustomEntity = async (id: string): Promise<boolean> => {
  try {
    const response = await fetch(`/api/custom-entities/${id}`, {
      method: "DELETE",
    });

    return response.ok;
  } catch (error) {
    console.error("Error deleting custom entity:", error);
    return false;
  }
};
